import { render, staticRenderFns } from "./clientProfileWorkflowStages.vue?vue&type=template&id=08515a34&scoped=true"
import script from "./clientProfileWorkflowStages.vue?vue&type=script&lang=js"
export * from "./clientProfileWorkflowStages.vue?vue&type=script&lang=js"
import style0 from "./clientProfileWorkflowStages.vue?vue&type=style&index=0&id=08515a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08515a34",
  null
  
)

export default component.exports